import { addDoc, collection } from "firebase/firestore";
import { Formik } from "formik";
import React, { useContext, useState } from "react";
import { GrFormClose } from "react-icons/gr";
import * as Yup from "yup";
import Modal from "../../../components/Modal";
import TextInput from "../../../components/TextInput";
import { auth, db } from "../../../utils/firebase";
import { collectionNames } from "../../../utils/Constants";
import Button from "../../../components/Button";

const AddNewSession = ({ onClose, getSessions }) => {
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
   
  });

  const addHandler = async (values) => {
    
    try {
      const docRef = await addDoc(collection(db, collectionNames.SESSIONS), {
        ...values,
        userId: auth.currentUser.email,
        status: "active",
        timestamp: new Date(),
        startTimeStamp:new Date(),
       
      });
      onClose();
      await getSessions();
      alert("Created successfully");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal>
      <div className="">
        <div className="max-w-lg">
          <div className="flex items-center justify-between">
            <p className="font-bold text-lg text-black">Add New Session</p>
            <GrFormClose
              size={18}
              onClick={onClose}
              className="text-gray-800 cursor-pointer"
            />
          </div>
          <Formik
            initialValues={{ name: "" }}
            validationSchema={validationSchema}
            onSubmit={addHandler}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue
            }) => (
              <form onSubmit={handleSubmit} className="flex flex-col ">
                <TextInput
                  label="Name"
                  errors={errors}
                  touched={touched}
                  type={"text"}
                  name={"name"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.name}
                />
              

                <Button
                  label={`${"Create"}`}
                  containerStyle={"mt-5 "}
                  type="submit"
                />
              </form>
            )}
          </Formik>
        </div>
      </div>
    </Modal>
  );
};

export default AddNewSession;
